import React from 'react';
import { withState, withHandlers, compose } from 'recompose';
import { connect } from 'react-redux';
import { withSafeTimeout } from '../../../../../common/hocs/withSafeTimeout';
import { activeFacebookPagePlanInfoSelector } from "@mm/state/selectors/facebookPageSelector";
import { getFbPageIdSelector } from "@mm/state/selectors/viewSelectors";
import SendToMessenger
  from '../../../../../common/components/facebook-plugin-components/SendToMessenger/SendToMessenger';
import '../LandingPageDetails/LandingPageDetails.scss';
import './LandingPagePreview.scss';
import { MESSENGER_BUTTON_MESSAGES } from '../../constants/constants'
import { get } from 'lodash';

const iFrameWidth = 256;
const defaultPadding = 38;

const getPaddingByButtonWidth = (mirageFacebookRef) => {
  const buttonWidth = get(mirageFacebookRef, 'current.clientWidth', null);
  return buttonWidth ? (iFrameWidth - buttonWidth) : defaultPadding;
};

const useAlignСenterFacebookIframe = () => {
  const mirageFacebookRef = React.useRef(null);
  const [padding, setPadding] = React.useState(defaultPadding);

  React.useEffect(() => {
    setPadding(getPaddingByButtonWidth(mirageFacebookRef));
  });
  return [padding, mirageFacebookRef]
};

const LandingPagePreview = props => {
  const {
    selectedEntity, LandingPageDesignProps,
    fbInitialized, fbAppId, pages,
    fbPageId, chatbot, showLink,
    formImageUrl, formImageNewUrl,
    freeOrSpecialPlan,
    handleSendToMessengerEvents,
    formMsgButtonText,
  } = props;

  const { formPageId } = LandingPageDesignProps;
  const [padding, mirageFacebookRef] = useAlignСenterFacebookIframe();

  const page = formPageId && pages.find(p => p.id === formPageId);
  const buttonText = MESSENGER_BUTTON_MESSAGES[formMsgButtonText];

  // Fallback to chatobot searchToken if no page found
  const searchToken = chatbot && page
    ? page.searchToken
    : chatbot && chatbot.searchToken;

  const showSendToMessenger = !!(fbInitialized && fbAppId && chatbot && fbPageId && searchToken);

  let imgUrl = '';

  if (selectedEntity) {
    if (formImageNewUrl) {
      imgUrl = `${selectedEntity.landingBaseUrl}${formImageNewUrl}`;
    } else if (formImageUrl) {
      imgUrl = `${selectedEntity.landingBaseUrl}${formImageUrl}?${Date.now()}`;
    }
  }

  return (
    <div
      className="landing-page-details__col"
      style={{ backgroundColor: props.formBgColor }}
    >
      <div className="landing-page-preview__main-container">
        <div>
          {imgUrl && (
            <img src={imgUrl} alt="" className="landing-page-preview__image" />
          )}
        </div>
        <div className="landing-page-preview__heading">
          {LandingPageDesignProps.formPageHeading}
        </div>
        <div>
          <pre
            className="landing-page-preview__text"
            style={{ textAlign: LandingPageDesignProps.formTextAlignment }}
          >
            {LandingPageDesignProps.formPageText}
          </pre>
        </div>
        {!showLink && showSendToMessenger && (
          <div
            className="landing-page-preview__messenger-container"
            style={{ paddingLeft: `${padding}px` }}
          >
            <SendToMessenger
              appId={fbAppId}
              pageId={fbPageId}
              passthroughParams={searchToken}
              color="blue"
              size="xlarge"
              onClick={handleSendToMessengerEvents}
              ctaText={formMsgButtonText}
            />
          </div>
        )}
        {showLink && (
          <div className="landing-page-preview__link">
            <a
              href={`http://m.me/${fbPageId}?ref=${searchToken}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open in Messenger
            </a>
          </div>
        )}
        {freeOrSpecialPlan && (
          <div className="landing-page-preview__powered-container">
            Powered by &nbsp;
            <a
              href="https://customers.ai"
              target="_blank"
              rel="noopener noreferrer"
            >
              Customers.ai
            </a>
          </div>
        )}
        <div
          ref={mirageFacebookRef}
          className={'landing-page-preview__mirage-button-container'}
        >
          <span className={'landing-page-preview__icon'} />
          <span className={'landing-page-preview__button_text'}>
            {buttonText}
          </span>
        </div>
      </div>
    </div>
  );
}

const handleSendToMessengerEvents = ({ setShowLink }) => () => {
  setShowLink(true);
};

const mapStateToProps = state => ({
  fbPageId: getFbPageIdSelector(state),
  chatbot: state.chatbot.activeChatbot,
  fbAppId: state.env.fbAppId,
  fbInitialized: state.facebook.isInitialized,
  pages: state.page.dropdown,
  freeOrSpecialPlan: activeFacebookPagePlanInfoSelector(state).info.isFreeOrSpecialPlan,
});


const enhance = compose(
  withSafeTimeout,
  connect(mapStateToProps),
  withState('showLink', 'setShowLink', false),
  withHandlers({ handleSendToMessengerEvents }),
);

export default enhance(LandingPagePreview);
